<script>
import { ref, onMounted } from 'vue';
import { useStampAnimation } from './useStampAnimation';

/**
 * 1帯セル (StampCell)。
 *
 * Props:
 *   - acquired: bool 既に取得済みなら true (赤スタンプ overlay)
 *   - isNew: bool 当該セルが新規取得 (= マウント時に落下アニメ実行)
 *   - label: string 帯ラベル (slot1/2/3 や 時刻表記)
 *   - inactive: bool イベント期間外の帯 (初日開始前 / 最終日終了後) なら true で空欄表示
 */
export default {
    name: 'StampCell',
    props: {
        acquired: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
        label: { type: String, default: '' },
        ajisaiImageUrl: { type: String, default: '' },
        inactive: { type: Boolean, default: false },
    },
    setup(props) {
        const activeStyleRef = ref('');
        const animate = useStampAnimation(activeStyleRef);

        onMounted(async () => {
            if (props.isNew && props.acquired) {
                await animate();
            }
        });

        return { activeStyleRef };
    },
};
</script>

<template>
    <!-- class は out-of-period を使う。 グローバル汎用 .inactive (暗幕 ::before) との衝突回避 -->
    <div class="stamp-cell" :class="{ acquired, 'out-of-period': inactive }">
        <!-- イベント期間外 (初日開始前 / 最終日終了後) の帯は空欄 -->
        <template v-if="!inactive">
            <div v-if="label" class="stamp-cell-label">{{ label }}</div>
            <div v-if="acquired" class="overlay-get" :style="isNew ? activeStyleRef : ''">
                <img v-if="ajisaiImageUrl" :src="ajisaiImageUrl" alt="獲得" class="stamp-image">
                <div v-else class="inner">獲得</div>
            </div>
            <div v-else class="stamp-cell-empty">○</div>
        </template>
    </div>
</template>

<style scoped>
.stamp-cell {
    position: relative;
    width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2px;
}
.stamp-cell.acquired {
    background: #fff;
}
.stamp-cell.out-of-period {
    background: transparent;
    border-style: dashed;
    border-color: #ececec;
}
.stamp-cell-label {
    position: absolute;
    top: 2px;
    left: 4px;
    font-size: 9px;
    color: #888;
}
.stamp-cell-empty {
    color: #ccc;
    font-size: 24px;
}
.overlay-get {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    /* ⚠️ 大きい値にしないこと。 .stamp-cell は position:relative だが z-index を
       持たない＝重ね合わせコンテキストを作らないので、ここの値がページ全体で効く。
       10 にしていたら固定ヘッダー(.header.fixed = z-index:3)より前に出て、
       スクロール中にスタンプ印がメニューへ被っていた。
       必要なのはセル内の ラベル/空マル より前に出ることだけなので 1 で足りる。 */
    z-index: 1;
}
.overlay-get .inner {
    font-size: 18px;
    font-weight: 900;
    color: #f00;
    border: 2px solid #f00;
    padding: 2px 6px;
    border-radius: 4px;
    transform: rotate(-10deg);
    background: rgba(0, 0, 0, 0.4);
    line-height: 1;
}
.overlay-get .stamp-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}
</style>
